import { useContext, useState } from "react";

import { Link, useNavigate } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";
import { ToastContext } from "../Components/ToastProvider";
import usePageTitle from "../hooks/usePageTitle";
import LoadingButton from '../Components/LoadingButton';

function ForgotPassword(id) {
  const { error, requestPasswordReset } = useAuth();

  const { createToast, dismissToast } = useContext(ToastContext);

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [disabled, setDisabled] = useState(false);

  const handleSubmit = (event) => {
    setDisabled(true);
    event.preventDefault();
    dismissToast(id);
    requestPasswordReset(email).then(async (success) => {
      if (success) {
        createToast(
          "You will receive an email from us shortly, if your email is registered already. 💌",
          "success",
          true
        );
        navigate("/login");
      } else {
        createToast("Something went wrong. Please try again", "error");
        setDisabled(false);
      }
    });
  };

  usePageTitle(`Forgot Password | Fudopia | Meet. Eat. Repeat.`);

  return (
    <div>
      {error && <p className="error-message">Something went wrong...</p>}
      <h1>Reset Password</h1>
      <p>
        Just enter the email address you registered with and <br /> we’ll send
        you a link to reset your password.
      </p>
      <form id="forgot-password-form" onSubmit={handleSubmit}>
        <label htmlFor="email">Your Email</label>
        <input
          id="email"
          type="email"
          required
          value={email}
          onChange={(event) => {
            setEmail(event.target.value);
          }}
        ></input>
        <LoadingButton
          type="submit"
          disabled={disabled}
          color="primary"
          variant="contained"
        >
          Send Password Reset Link
        </LoadingButton>
        <p className="margin-t-40 underline">
          <Link to="/login">Login</Link>
        </p>
        <p className="underline">
          <Link to="/register">Register</Link>
        </p>
      </form>
    </div>
  );
}

export default ForgotPassword;
